/*
 * @Author: 
 * @Date: 2021-01-11 09:30:38
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-07 00:16:30
 * @Description: file content
 * 
 */
// const Mock = require('mockjs');
// import baseFakeData from "./base-fake-data";
export default {
    protocol: "",
    domain: "",
    action: {
        // 页面配置信息 -ui
        getConfig: {
            api: "circle-act-game-assistance/act/m/page/getConfig",
            method:'get',
            contentType:'json',
            mock: function () {
                return {
                    msg: "success",
                    code: 0,
                    data: {
                        value: "这里是假数据"
                    }
                }
            }
        },
        // 参与 围观人数
        counts:{
            api: "circle-act-game-assistance/act/m/page/counts",
            method:'get',
            contentType:'json',
        },
        // 轮播中奖信息
        homePrizeLogs:{
            api: "circle-act-game-assistance/act/m/page/homePrizeLogs",
            method:'get',
            contentType:'json',
        },
        // 获取排行榜奖品
        getRankPrize:{
            api: "circle-act-game-assistance/act/m/page/getRankPrize",
            method:'get',
            contentType:'json',
        },
        // 获取抽奖奖品
        getPageLotteryPrize:{
            api: "circle-act-game-assistance/act/m/page/getLotteryPrize",
            method:'get',
            contentType:'json',
        },
        // 获取优惠券奖品
        getCouponPrize:{
            api: "circle-act-game-assistance/act/m/page/getCouponPrize",
            method:'get',
            contentType:'json',
        },
        // 获取项目展示列表
        getProjectList:{
            api: "circle-act-game-assistance/act/m/salesSite/listSalesSite",
            method:'post',
            contentType:'json',
            type:'query'
        },

        // 参与活动
        participation:{
            api: "circle-act-game-assistance/act/m/common/user/participation",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取游戏次数
        getGameNum:{
            api: "circle-act-game-assistance/act/m/user/getUserLotteryTimesRemain",
            // method:'post',
            // contentType:'json',
            // type:'body'
            method:'get',
            contentType:'json',
        },
        // 获取分享排行榜
        getShareRank:{
            api: "circle-act-game-assistance/act/m/user/getShareRank",
            method:'get',
            contentType:'json',
        },
        // 获取助力排行榜
        getAssistanceRank:{
            api: "circle-act-game-assistance/act/m/user/getAssistanceRank",
            method:'get',
            contentType:'json',
        },

        // 预约详情
        infoList: {
            api: "circle-act-game-assistance/act/m/common/appointment/infoList",
            method:'get',
            contentType:'json',
        },
        signUp: {
            api: "circle-act-game-assistance/act/m/common/appointment/signUp",
            method:'post',
            contentType:'json',
            type:'body'
        },
        signUpDetail: {
            api: "circle-act-game-assistance/act/m/common/appointment/signUpDetail",
            method:'get',
            contentType:'json',
        },
        
        // 获取我的奖品
        getMyPrize:{
            api: "circle-act-game-assistance/act/m/prize/myPrize",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 抽奖
        lottery:{
            api: "circle-act-game-assistance/act/m/prize/lottery",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 领奖
        receive:{
            api: "circle-act-game-assistance/act/m/prize/receive",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 领助力奖
        receiveAssistancePrize:{
            api: "circle-act-game-assistance/act/m/prize/receiveAssistancePrize",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 领助力值奖品
        assistanceReceive:{
            api: "circle-act-game-assistance/act/m/prize/assistanceReceive",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 领券
        receiveCoupon:{
            api: "circle-act-game-assistance/act/m/prize/receiveCoupon",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 核销
        writeOff:{
            api: "circle-act-manager/act/prize/writeOff",
            method:'post',
            contentType:'json',
            type:'path'
        },
        getPrizeInfo:{
            api: "circle-act-manager/act/prize/getPrizeInfo",
            method:'post',
            contentType:'json',
            type:'path'
        },
        // 获取验证码
        getSmsCode:{
            api: "circle-act-game-assistance/act/m/common/smsCode",
            method:'post',
            contentType:'json',
            type:'query'
        },
        // 分享
        share:{
            api: "circle-act-game-assistance/act/m/common/user/share",
            method:'post',
            contentType:'json',
            type:'query'
        },
        // 查询当前用户是否是销售
        getSaleByOpenId:{
            api: "circle-act-game-assistance/act/m/sale/getSaleByOpenId",
            method:'get',
            contentType:'json',
            type:'path'
        },
        // 获取当前用户助力值
        getAssistanceNumber:{
            api: "circle-act-game-assistance/act/m/user/getAssistanceNumber",
            method:'get',
            contentType:'json',
        },
        // 获取我的好友
        getAssistanceUser:{
            api: "circle-act-game-assistance/act/m/user/getAssistanceUser",
            method:'get',
            contentType:'json',
        },
        // 获取我的好友
        getNewUser:{
            api: "circle-act-game-assistance/act/m/user/getNewUser",
            method:'get',
            contentType:'json',
        },
        // 获取我的奖品code
        getReceivePrizeCode:{
            api: "circle-act-game-assistance/act/m/user/getReceivePrizeCode",
            method:'get',
            contentType:'json',
        },
        // 获取点亮人数
        accomplishLightCount:{
            api: "circle-act-game-assistance/act/m/page/accomplishLightCount",
            method:'get',
            contentType:'json',
        },
        // 获取站点
        getSite:{
            api: "circle-act-game-assistance/act/m/user/getSite",
            method:'get',
            contentType:'json',
        },
        // 站点抽奖
        assistanceLottery:{
            api: "circle-act-game-assistance/act/m/common/user/lottery",
            method:'post',
            contentType:'json',
        },
        // 站点奖品列表
        sitePrizeList:{
            api: "circle-act-game-assistance/act/m/prize/sitePrizeList/",
            method:'post',
            contentType:'json',
        },
        // 锁定券库存
        lockCoupon:{
            api: "circle-act-game-assistance/act/m/common/prize/lockCoupon/",
            method:'post',
            contentType:'json',
        },
        // 获取支付链接
        getPaymentUrl:{
            api: "circle-act-game-assistance/act/m/web/getPaymentUrl",
            method:'post',
            contentType:'json',
        },

        // 领奖 - 后台锁定奖品 通过receiveKey领取
        receiveV2:{
            api: "circle-act-game-assistance/act/m/common/prize/receive",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 领奖 - 后台未锁定奖品 通过prizeCode 领取
        win:{
            api: "circle-act-game-assistance/act/m/common/prize/win",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取分享所需要的appid
        getShareAppId:{
            api: "circle-act-game-assistance/act/m/common/getShareAppId",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取用户领奖次数余额
        getWinTimesRemain:{
            api: "circle-act-game-assistance/act/m/user/getWinTimesRemain",
            method:'get',
            contentType:'json',
            type:'body'
        },
        // 立即回收奖品
        recycle:{
            api: "circle-act-game-assistance/act/m/common/prize/recycle",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取活动多人活码
        getWeChatQrCode:{
            api: "circle-act-game-assistance/act/m/common/getWeChatQrCode",
            method:'post',
            contentType:'json',
            type:'body'
        },
        // 获取销售活码
        getSalesWeChatQrCode:{
            api: "circle-act-game-assistance/act/m/common/getSalesWeChatQrCode",
            method:'post',
            contentType:'json',
            type:'query'
        },
         // 获取佣金排行榜
         getShareUrl:{
            api: "circle-act-game-assistance/act/m/common/getShareUrl",
            method:'post',
            contentType:'json',
            type:'body'
        },
         // 获取今日分享次数
         getTodayShareCount:{
            api: "circle-act-game-assistance/act/m/common/user/getTodayShareCount",
            method:'post',
            contentType:'json',
            type:'body'
        },  
        // 获取签到记录
        getSignRecord:{
           api: "circle-act-game-assistance/act/m/user/getSignRecord",
           method:'post',
           contentType:'json',
           type:'body'
       },
        // 签到  
        sign:{
           api: "circle-act-game-assistance/act/m/user/sign",
           method:'post',
           contentType:'json',
           type:'body'
       },
       // 浏览项目
       browseProject:{
          api: "circle-act-game-assistance/act/m/user/browseProject",
          method:'post',
          contentType:'json',
          type:'body'
      },
       // 获取我的积分
       myPoint:{
          api: "circle-act-game-assistance/act/m/user/myScore",
          method:'post',
          contentType:'json',
          type:'body'
      },
      // 获取拉新总数
      getNewUserCount:{
         api: "circle-act-game-assistance/act/m/user/getNewUserCount",
         method:'get',
         contentType:'json',
         type:'body'
     },
      // 获取项目浏览总数
      getBrowseProjectCount:{
         api: "circle-act-game-assistance/act/m/user/getBrowseProjectCount",
         method:'post',
         contentType:'json',
         type:'body'
     },
      // 直播预约
      appointmentLive:{
         api: "circle-act-game-assistance/act/m/user/appointmentLive",
         method:'post',
         contentType:'json',
         type:'body'
     },
      // 获取抽奖奖金
      getLotteryPrize:{
         api: "circle-act-game-assistance/act/m/prize/getLotteryPrize",
         method:'get',
         contentType:'json',
         type:'body'
     },
      // 获取直播预约次数
      getAppointmentLiveCount:{
         api: "circle-act-game-assistance/act/m/user/getAppointmentLiveCount",
         method:'post',
         contentType:'json',
         type:'body'
     },
      // 获取抽奖次数
      getLotteryCount:{
         api: "circle-act-game-assistance/act/m/user/getLotteryCount",
         method:'get',
         contentType:'json',
         type:'body'
     },
     //投诉
     complaint:{
         api: "circle-act-manager/h5/complaint/save",
         method:'post',
         contentType:'json',
         type:'body'
     },
    },
}